var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlask = function SvgFlask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E2F3C",
    d: "M15.587 14.046 11.25 6.815V2.812h.562a.562.562 0 1 0 0-1.124H6.187a.563.563 0 1 0 0 1.125h.563v4.002l-4.338 7.231a1.125 1.125 0 0 0 .963 1.704h11.25a1.125 1.125 0 0 0 .964-1.704zM7.795 7.26a.56.56 0 0 0 .08-.29V2.814h2.25V6.97c0 .102.027.202.08.289l2.687 4.482c-.843.167-2.044.096-3.638-.71-1.12-.567-2.184-.867-3.18-.901zm-4.42 7.365L5.38 11.28c1.002-.123 2.132.13 3.363.753 1.336.676 2.46.906 3.375.906.465.002.928-.062 1.374-.19l1.132 1.876z"
  })));
};
export default SvgFlask;